import Vue from 'vue';

Vue.component('model-dropdown-component', {
    props: ['defaultValue', 'cdnUrl', 'errors', 'emptyModelErrorMessage'],

    data() {
        return {
            selectedDropdownValue: '',
            dropdownValue: null,
            dropdownImage: '',
        };
    },

    mounted() {
        if (this.defaultValue) {
            const defaultValueTarget = document.getElementById(
                this.defaultValue,
            );
            const defaultValueTargetValue = defaultValueTarget.dataset.value;
            const defaultValueTargetText = defaultValueTarget.dataset.text;
            const defaultValueTargetImage = defaultValueTarget.dataset.image;

            this.dropdownValue = defaultValueTargetText;
            this.selectedDropdownValue = defaultValueTargetValue;
            this.dropdownImage = this.cdnUrl + defaultValueTargetImage;
        }

        EventBus.$on('update-model-dropdown', (selectedPlanValue) => {
            const dropdownElement = document.getElementById(selectedPlanValue);
            if (!dropdownElement) return;
            this.selectedDropdownValue = selectedPlanValue;
            this.dropdownValue = dropdownElement.dataset.text;
            this.dropdownImage = this.cdnUrl + dropdownElement.dataset.image;
        });
    },

    computed: {
        hasModelSelectionError() {
            if (!this.errors || !this.errors.errors) {
                return false;
            }

            const modelErrors = this.errors.errors.model || [];
            const expectedErrorMessage = this.emptyModelErrorMessage;

            if (!expectedErrorMessage) {
                return false;
            }

            return modelErrors.some((error) =>
                error.includes(expectedErrorMessage),
            );
        },
    },

    methods: {
        setDropdownValue(event) {
            event.preventDefault();
            this.dropdownValue = event.currentTarget.dataset.text;
            this.toggleDropdown(event);

            const value = event.currentTarget.dataset.value;
            this.selectedDropdownValue = value;
            this.dropdownImage =
                this.cdnUrl + event.currentTarget.dataset.image;

            this.$parent.model = value;
            if ('resetCountries' in this.$parent) {
                this.$parent.resetCountryDropdown();
            }
        },

        toggleDropdown(event) {
            let element = event.currentTarget;

            while ((element = element.parentElement)) {
                if (element.classList.contains('dropdown')) {
                    element.classList.toggle('dropdown--active');
                }
            }
        },
        // Hotfix for removing year 2023 from model name
        // that should be used until we find alternative solution
        // or until all the countries use hs and ehs model from 2023
        newModelsFormatHotfix(modelName) {
            if (!modelName) {
                return '';
            }
            return modelName.replace(' 2023', '');
        },
    },
});
